import { render } from "./GdprLogs.vue?vue&type=template&id=439ae376"
import script from "./GdprLogs.vue?vue&type=script&lang=ts"
export * from "./GdprLogs.vue?vue&type=script&lang=ts"
script.render = render

export default script